import React from 'react'

function Footer() {
  return (
    <div>
            <p className='header_Problem'>Contact</p>
            <p className='contact_info'>
                If you have any questions, raise an issue on <a href="https://github.com/facebook/create-react-app/issues"> GitHub</a>.
            </p>

      <p>Copyright © IIT Jodhpur</p>
    </div>
  )
}

export default Footer
